{
  "linkTo": "Imposta posizione",
  "locationNotPinned": "Posizione sbloccata",
  "locationPinned": "Posizione bloccata",
  "locationPinnedExplanation": "\"Posizione bloccata\" significa che la posizione del dispositivo è stata impostata manualmente e verrà utilizzata al posto della posizione GPS.",
  "locationUnpinnedExplanation": "\"Posizione non rilevata\" significa che la posizione del dispositivo viene determinata dal chip GPS.",
  "pinnedLocation": "Posizione bloccata",
  "pinningExplanation": "Il pinning della posizione del dispositivo sovrascriverà la lettura corrente dal chip GPS. Potresti volerlo fare se il tuo dispositivo ha una ricezione GPS costantemente scarsa, ad esempio una pompa installata all'interno di un magazzino con un tetto di metallo.",
  "tapTheMapToSetLocation": "Tocca la mappa per impostare la posizione permanente",
  "title": "Posizione del dispositivo Pin",
  "unpinButton": "Chiaro"
}
